export default {
    Administration: 'Administration',
    PartnerList: 'Partners',
    CJBlockManagement: 'CJ Block Management',
    AddPartner: 'Add Partner',
    RemovePartner: 'Remove Partner',
    RemovePartners: 'Remove Partners',
    AdministrationProviders: 'Administration Providers',
    AdministrationEmailProviders: 'Administration Email Providers',
    AdministrationSMSProviders: 'Administration SMS Providers',
    AdministrationSettings: 'Administration Settings',
    AddSetting: 'Add Setting',
    Setting: 'Setting',
    EditSetting: 'Edit Setting',
    CloneSetting: 'Clone Setting',
    DeleteSetting: 'Delete Setting',
    SettingWasEditedSuccessfully: 'The setting was edited successfully',
    SettingWasClonedSuccessfully: 'The setting was cloned successfully',
    SettingWasCreatedSuccessfully: 'The setting was created successfully',
    BaseKind: 'Base Kind',
    SettingName: 'Setting Name',
    PartnerName: 'Partner Name',
    SelfKind: 'Self Kind',
    CreateSetting: ' Create Setting',
    Value: 'Value',
    EditProvider: 'Edit Provider',
    CloneProvider: 'Clone Provider',
    CreateEmailProvider: 'Create Email Provider',
    CreateSMSProvider: 'Create SMS Provider',
    EditEmailProvider: 'Edit Email Provider',
    EditSMSProvider: 'Edit SMS Provider',
    CloneEmailProvider: 'Clone Email Provider',
    CloneSMSProvider: 'Clone SMS Provider',
    ChooseProvider: 'Choose Provider',
    ResponseRegex: 'Response Regex',
    RequestType: 'Request Type',
    MediaType: 'Media Type',
    PostMessageBody: 'Post Message Body',
    MaxDegreeOfParallelism: 'Max Degree Of Parallelism',
    AdditionalFieldsJson: 'Additional Fields Json',
    AddField: 'Add Field',
    AddNestedFields: 'Add Nested Fields',
    NestedFields: 'Nested Fields',
    SMSProvidersList: 'SMS Providers List',
    Properties: 'Properties',
    ReplaceBy: 'Replace By',
    ErrorCode: 'Error Code',
    ErrorMessage: 'Error Message',
    ExternalId: 'External Id',
    DeliveryStatus: 'Delivery Status',
    SuccessCode: 'Success Code',
    DefaultCode: 'Default Code',
    CodeMap: 'Code Map',
    SMSProviderTest: 'SMS Provider Test',
    YouWillReceiveCRMTestMessage: 'You will receive "CRM Test" message',
    ProviderId: 'Provider Id',
    ProviderCreated: 'Provider Created',
    ProviderUpdated: 'Provider Updated',
    Port: 'Port',
    PartnerEmail: 'Partner Email',
    PartnerId: 'Partner Id',
    Parallelism: 'Parallelism',
    DelayTimeout: 'Delay Timeout',
    IsDefault: 'Is Default',
    IsCrmActivated: 'Is Crm Activated',
    Unknown: 'Unknown',
    Trial: 'Trial',
    Production: 'Production',
    Inactive: 'Inactive',
    Lost: 'Lost',
    Terminated: 'Terminated',
    PartnerTimeZone: 'Partner Time Zone',
    FiltersTimeZone: 'Filters Time Zone',
    Subscription: 'Subscription',
    SubscriptionName: 'Subscription Name',
    SubscriptionPlan: 'Subscription Plan',
    SelectSubscriptionPlan: 'Select Subscription Plan',
    Extensions: 'Extensions',
    ExtensionName: 'Extension Name',
    SelectExtension: 'Select Extension',
    AddExtension: 'Add Extension',
    UserId: 'User Id',
    ActiveClients: 'Clients (Active/Total)',
    Workflows: 'Workflows',
    Communications: 'Communications',
    IgnoreTrackedLinks: 'Ignore Tracked Links',
    AllowTrackEmailLinks: 'Email',
    AllowTrackInternalLinks: 'Internal',
    AllowTrackSMSLinks: 'SMS',
    AllowTrackTelegramLinks: 'Telegram',
    AllowTrackPopUpLinks: 'Builder PopUp',
    AllowTrackPushNotificationLinks: 'Push Notification',
    AllowTrackCMSPopUpLinks: 'CMS PopUp',
    AllowTrackViberLinks: 'Viber',
    AddLink: 'Add Link',
    Deactivate: 'Deactivate',
    Activate: 'Activate',
    Activated: 'Activated',
    Deactivated: 'Deactivated',
    AreYouSureYouWantToChangePartnerActivation: 'Are you sure you want to {{toState}} {{partnerId}} {{name}} partner.',
    AreYouSureYouWantToChangePartnerSettings: 'Are you sure you want to change {{partnerId}} {{name}} settings.',
    CRMIsNotActivated: 'CRM Is Not Activated',
    DataWarehouse: 'DataWarehouse',
    UIType: 'UIType',
    IsKPI: 'IsKPI',
    IsFilter: 'IsFilter',
    ExportType: 'ExportType',
    NotInjectUnsubscribeLink: 'Not Inject Unsubscribe Link',
    CreateClassifier: 'Create Classifier',
    EditClassifier: 'Edit Classifier',
    CloneClassifier: 'Clone Classifier',
    Classifiers: 'Classifiers',
    MenuItems: 'MenuItems',
    Id: 'Id',
    GroupId: 'GroupId',
    NumId: 'NumId',
    Options: 'Options',
    Query: 'Query',
    Classifier: 'Classifier',
    Custom: 'Custom',
    Multifield: 'Multifield',
    AdditionalFields: 'Additional Fields',
    DeleteClassifier: 'Delete Classifier',
    ClassifierWasCreatedSuccessfully: 'Classifier was created Successfully',
    ClassifierWasClonedSuccessfully: 'Classifier was clone Successfully',
    ClassifierWasUpdatedSuccessfully: 'Classifier was updated Successfully',
    CreateMenuItem: 'Create menuItem',
    EditMenuItem: ' Edit menuItem',
    CloneMenuItem: 'Clone menuItem',
    AdministrationClassifiers: 'Administration Classifiers',
    AdministrationMenuItems: 'Administration MenuItems',
    DeleteMenuItem: 'Delete menuItem',
    MenuItemWasCreatedSuccessfully: 'MenuItem was created successfully',
    MenuItemWasUpdatedSuccessfully: 'MenuItem was updated successfully',
    SystemMessage: 'System Message',
    MaintenanceDateAndTimeRangeUTC: 'Maintenance Date and Time Range (UTC)',
    PartnerGroupName: 'Partner Group Name',
    PartnerGroupId: 'Partner Group Id',
    PartnerGroup: 'Partner Group',
    PartnerGroupPermissionWarning: 'You do not have permission to change Partner Group settings',
    InternalPartnerId: 'Internal Partner Id',
    ExternalPartnerId: 'External Partner Id',
    // Knowledge Center administration
    KnowledgeCenterArticles: 'Knowledge Center Articles',
    CreateArticle: 'Create Article',
    EditArticle: 'Edit Article',
    CloneArticle: 'Clone Article',
    DeleteArticle: 'Delete Article',
    ArticleID: 'Article ID',
    ArticleName: 'Article Name',
    Parent: 'Parent',
    ParentID: 'Parent ID',
    ParentName: 'Parent Name',
    IsPublished: 'Is Published',
    CreatedBy: 'Created By',
    ModifiedBy: 'Modified By',
    Publish: 'Publish',
    Unpublish: 'Unpublish',
    PublishArticle: 'Publish Article',
    UnpublishArticle: 'Unpublish Article',
    AreYouSureYouWantToPublishArticle: 'Are you sure you want to publish {{name}} article?',
    AreYouSureYouWantToUnpublishArticle: 'Are you sure you want to unpublish {{name}} article?',
    AreYouSureYouWantToDeleteArticle: 'Are you sure you want to delete {{name}} article?',
    SaveArticle: 'Save Article',
    ArticleSavedSuccessfully: 'The article was saved successfully',
    SortOrder: 'Sort Order',
    Content: 'Content',
    Published: 'Published',
    WriteArticleContentInMarkdown: 'Write the article content in Markdown',
    HeadingLevel: 'Heading {{level}}',
    Bold: 'Bold',
    Italic: 'Italic',
    Strikethrough: 'Strikethrough',
    InlineCode: 'Inline Code',
    CodeBlock: 'Code Block',
    Quote: 'Quote',
    BulletedList: 'Bulleted List',
    NumberedList: 'Numbered List',
    TaskList: 'Task List',
    InsertImage: 'Insert Image',
    Paragraph: 'Paragraph',
    BlockType: 'Block Type',
    ImageByUrl: 'Image by URL',
    Table: 'Table',
    TableWithTitle: 'Table with Title',
    HorizontalLine: 'Horizontal Line',
    InfoBlock: 'Info Block',
    WarningBlock: 'Warning Block',
    ErrorBlock: 'Error Block',
    QuestionAndAnswer: 'Question and Answer',
    ChildArticlesList: 'Child Articles List',
    NoChildArticles: 'This article has no child articles',
    EditorInstructions: 'Editor Instructions',
    CopyInstructions: 'Copy Instructions',
    InstructionsCopied: 'The instructions are copied',
};
